import { axios } from "@/client/libs/axios";
import { FilterUserType } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import qs from "qs";

export const ExportXlsx = async () => {
  const filter = sessionStorage.getItem("Current_list");
  const response = await axios.get("user/export", {
    params: qs.parse(filter!),
    paramsSerializer: (params) => qs.stringify(params),
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "User.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const useExportUser = () => {
  const filter = sessionStorage.getItem("Current_list");
  const { refetch } = useQuery({
    queryKey: ["Export", filter],
    queryFn: ExportXlsx,
    enabled: false,
  });

  return { refetch };
};
